import { Grid, styled } from '@mui/material'

export const Container = styled(Grid)(({ theme }) => ({
  width: '70%',
  minHeight: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    width: '90%',
  },
}))

export const List = styled('ol')(({ theme }) => ({
  fontSize: theme.typography.h6.fontSize,
}))
